// covered-by: frontends/carrie/src/utils/__tests__/logoutUrl.test.ts
import { loginRoute } from "../routes/login/route";

// why: reading storage throws SecurityError rather than returning null when it is
// blocked (private mode, third-party-cookie blocking, sandboxed iframe). This runs
// from render on the logout path, so an unguarded read white-screens the redirect
// instead of falling back to a plain login URL.
function readLocalStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

/**
 * Absolute login URL used after mid-session logout (classic AuthLayout and
 * Ask V2). Preserves a stored post-login `redirect` when present.
 */
export function logoutUrl(basepath: string): string {
  if (basepath === "/") basepath = "";
  const redirect = readLocalStorage("redirect");
  const destination = new URL(location.origin + basepath + loginRoute.to);
  if (redirect) {
    destination.searchParams.append("redirect", redirect);
  }
  return destination.toString();
}
